module.exports = __webpack_public_path__ + "static/media/en-data-roaming-other_2.b5bf540c.png";